import React from "react";
import styles from "./DetailsSection.module.scss";

type DetailsSectionProps = {
  refunds: boolean;
  transfers: boolean;
  details?: string;
};

export default function DetailsSection({
  refunds,
  transfers,
  details,
}: DetailsSectionProps) {
  const refundsText = () =>
    refunds ? "Refunds will be available." : "No refunds will be available.";

  const transfersText = () =>
    transfers
      ? "Ticket transfers will be available."
      : "No ticket transfers will be available.";

  return (
    <div className={styles.contentSection}>
      <h3 className={styles.eventTitle}>Details</h3>
      <p className={styles.eventPageDetailsText}>• {refundsText()}</p>
      <p className={styles.eventPageDetailsText}>• {transfersText()}</p>
      {details && <p className={styles.eventPageDetailsText}>• {details}</p>}
    </div>
  );
}
